import { Box } from '@grupoboticario/flora-react'
import { memo } from 'react'
import { BrandName } from 'src/@enums'
import { IPin, IPinProduct } from 'src/@interfaces'
import { getPinIcon } from 'src/helpers'
import { useConfigCat } from 'src/hooks'
import { MagazinePin } from '../MagazinePin'

export type PinsMeshProps = {
  brand: BrandName
  loadingPinId?: string
  pins?: IPin[]
  onAdd?: (items: IPinProduct) => void
}

export const PinsMesh = memo(({ pins = [], loadingPinId, onAdd }: PinsMeshProps) => {
  const { featureFlags } = useConfigCat()

  const pinBagIcon = getPinIcon()

  return (
    <Box
      css={{
        height: '100%',
        width: '100%',
      }}
    >
      {pins.map((pin) => (
        <MagazinePin
          key={pin.id}
          pin={pin}
          catalogPinsSize={featureFlags.catalogPinsSize}
          pinBagIcon={pinBagIcon}
          loadingPinId={loadingPinId}
          onAdd={onAdd}
        />
      ))}
    </Box>
  )
})
